import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchWFourDetail = createAsyncThunk(
  "fetchWFourDetail",
  async ({ id }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axiosHttp.get(`wfour/detail/${id}`, config);
    return response.data.data;
  }
);

const WFourDetailSlice = createSlice({
  name: "WFourDetail",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWFourDetail.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchWFourDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchWFourDetail.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default WFourDetailSlice.reducer;
